/**
 * Parse SDK 通过 CDN 加载到 window.Parse，此处仅做导出，避免 Vite 打包 Parse 导致 "Super expression must either be null or a function"。
 */
const Parse = typeof window !== 'undefined' ? window.Parse : undefined;
if (!Parse) {
  throw new Error('Parse SDK 未加载。请先执行 npm install，并确保 index.html 中已引入 /vendor/parse.min.js。');
}

export default Parse;
